<template>
  <v-text-field
    v-model="searchValue"
    :label="$t('searchAlerts') + ' ' + addToLabel"
    append-inner-icon="mdi-magnify"
    clearable
    dense
    outlined
    hide-details
    class="search-field"
    color="primary"
    bg-color="surface"
  />
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    addToLabel: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    searchValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style scoped>
.search-field {
  transition: all 0.3s ease;
}

.search-field:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>

<style>
[dir="rtl"] .v-field {
  direction: rtl !important;
}
[dir="rtl"] .v-field {
  direction: rtl !important;
}
</style>
